const $const = {
    LOCAL_STORAGE_KEY: {
        TOKEN: 'token',
        PROVIDER: 'provider'
    }
}
export default $const
